var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66658 4.66667C8.66658 6.13943 7.47265 7.33333 5.99992 7.33333C4.52716 7.33333 3.33325 6.13943 3.33325 4.66667C3.33325 3.19391 4.52716 2 5.99992 2C7.47265 2 8.66658 3.19391 8.66658 4.66667Z",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.33333C11.4727 7.33333 12.6667 6.13943 12.6667 4.66667C12.6667 3.19391 11.4727 2 10 2",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 12.6666C10.6666 10.8257 9.17419 9.33325 7.33325 9.33325H4.66659C2.82564 9.33325 1.33325 10.8257 1.33325 12.6666V13.9999H10.6666V12.6666Z",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 13.9999H14.6666V12.6666C14.6666 10.8257 13.1742 9.33325 11.3333 9.33325",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp);
export default __webpack_public_path__ + "static/media/mp.7773e94dd7d8e5684c9a09de6bd91ab2.svg";
export { ForwardRef as ReactComponent };